export default (state, action) => {
  return Object.assign({}, state, { loadMoreItems: action.data });
};
